// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","uploadForm":"CertificateUploadForm__uploadForm--jM","portConfig":"CertificateUploadForm__portConfig--F6"};